import { render, staticRenderFns } from "./Releases.vue?vue&type=template&id=7f53dfe0&scoped=true"
import script from "./Releases.vue?vue&type=script&lang=js"
export * from "./Releases.vue?vue&type=script&lang=js"
import style0 from "./Releases.vue?vue&type=style&index=0&id=7f53dfe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f53dfe0",
  null
  
)

export default component.exports